import { Card, Col, Container, Placeholder, Row } from "react-bootstrap";

const Block = ({ className, width = "100%", height = "16px" }) => (
  <Placeholder as="div" animation="glow" className={className} style={{ width, height }}>
    <Placeholder xs={12} />
  </Placeholder>
);

const DetailPropertySkeleton = () => {
  return (
    <Container className="detail-property-shell detail-property-page detail-property-loading">
      <Row className="g-4">
        <Col xs={12}>
          <Card className="detail-card">
            <Card.Body>
              <Block className="detail-skeleton-image" height="460px" />
            </Card.Body>
          </Card>
        </Col>

        <Col lg={8}>
          <Card className="detail-card">
            <Card.Body>
              <Block className="detail-skeleton-title" width="60%" />
              <Block className="detail-skeleton-location mt-3" width="38%" />
              <Block className="detail-skeleton-price mt-3" width="28%" />
              <Block className="detail-skeleton-line mt-4" width="100%" />
              <Block className="detail-skeleton-line mt-2" width="92%" />
              <Block className="detail-skeleton-line mt-2" width="96%" />
            </Card.Body>
          </Card>

          <Card className="detail-card mt-4">
            <Card.Body>
              <Block className="detail-skeleton-line" width="45%" />
              <Block className="detail-skeleton-line mt-2" width="100%" />
              <Block className="detail-skeleton-line mt-2" width="100%" />
            </Card.Body>
          </Card>
        </Col>

        <Col lg={4}>
          <Card className="detail-card">
            <Card.Body>
              <Block className="detail-skeleton-contact-card" height="420px" />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default DetailPropertySkeleton;
